import styled from 'styled-components';
import { WppIconCross, WppTypography } from '@wppopen/components-library-react';

export const Main = styled.div`
    display: block;
`;

export const CrossIcon = styled(WppIconCross)`
    cursor: pointer;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const HeaderText = styled(WppTypography)`
    cursor: pointer;
    color: var(--wpp-brand-color);
    font-size: 16px;
    font-weight: 400;
`;
